

import React, { useState, useRef } from "react";
import Grocerymanagement2 from "./Grocerymanagement2";
import { useNavigate } from "react-router-dom";
import Grocerymenudatas from "./importmenupages/Grocerymenudatas";

function GroceryCategories() {

  const [activeTab, setActiveTab] = useState("first");
  const navigate = useNavigate();

  const [showPopup, setShowPopup] = useState(false);
  const [image, setImage] = useState(null);
  const [text, setText] = useState('');



  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSave = () => {
    if (!text || !image) {
      alert("Please fill in all fields.");
      return;
    }
    console.log("Saved category:", text, image);
    // Reset state
    setShowPopup(false);
    setImage(null);
    setText("");
  };




  const styles = {
    overlay: {
      position: "fixed",
      top: 0, left: 0,
      width: "100%", height: "100%",
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex", justifyContent: "center", alignItems: "center",
      zIndex: 1000,
    },
    popup: {
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "10px",
      width: "300px",
      position: "relative",
    },
    input: {
      width: "90%",
      padding: "10px",
      marginTop: "10px",
      fontSize: "16px",
    },
    buttons: {
      textAlign: "center",
      marginTop: "15px",
    },
    saveBtn: {
      padding: "10px 20px",
      backgroundColor: "#4CAF50",
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      fontSize: "16px",
      cursor: "pointer",
    }
  };



  return (
    <div>
      {/* Tab Headers */}

      <div className="tavheders"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          marginBottom: "0rem",
          // marginTop: '-57px',
          gap: "1rem",
        }}
      >
        {/* Left Buttons: Menu, Add Items, Veg/Non-Veg Switch */}
        <div className="leftbuttonmenu" style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
          marginTop: "60px",
          marginBottom: "47px",
          flexDirection: window.innerWidth <= 768 ? "column" : "row", // stack on mobile
        }}>
          <div className="menubutton"
            style={{
              padding: "10px 20px",
              border: "none",
              backgroundColor: activeTab === "first" ? "#b15cd6" : "#d9d9d9",
              color: activeTab === "first" ? "white" : "#000",
              borderRadius: "5px",
              cursor: "pointer",
              transition: "all 0.3s",
              fontWeight: "bold",
              boxShadow: activeTab === "first" ? "0 2px 5px rgba(0,0,0,0.2)" : "none",
              width: window.innerWidth <= 558 ? "300px" : "auto", // ✅ full width on mobile
              textAlign: "center",
            }}
            onClick={() => navigate("/grocerymenudatas")}
          >
            Menu
          </div>

          <div className="additembutton"
            style={{
              padding: "10px 20px",
              border: "none",
              backgroundColor: activeTab === "first" ? "#b15cd6" : "#d9d9d9",
              color: activeTab === "first" ? "white" : "#000",
              borderRadius: "5px",
              cursor: "pointer",
              transition: "all 0.3s",
              fontWeight: "bold",
              boxShadow: activeTab === "first" ? "0 2px 5px rgba(0,0,0,0.2)" : "none",
              width: window.innerWidth <= 558 ? "300px" : "auto", // ✅ full width on mobile
              textAlign: "center",
            }}
            onClick={() => setActiveTab("first")}
          >
            Add Items
          </div>

          {showPopup && (
            <div style={styles.overlay}>
              <div style={styles.popup}>

                <div
                  style={{
                    position: 'absolute',
                    fontSize: '20px',
                    cursor: 'pointer',
                    color: '#888',
                    fontWeight: 'bold',
                    marginLeft: "243px",
                    marginTop: "-18px"
                  }}
                  onClick={() => setShowPopup(false)}
                >
                  ×
                </div>

                <h3>Add Item</h3>


                <div
                  style={{
                    width: '141px',
                    height: '123px',
                    border: '2px dashed #aaa',
                    borderRadius: '8px',
                    margin: '10px auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    backgroundColor: '#f9f9f9',
                    overflow: 'hidden',
                  }}
                  onClick={() => document.getElementById('hiddenFileInput').click()}
                >
                  {image ? (
                    <img
                      src={image}
                      alt="Preview"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  ) : (
                    <div style={{ fontSize: '40px', color: '#bbb', fontWeight: 'bold' }}>+</div>
                  )}
                </div>

                <input
                  id="hiddenFileInput"
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  style={{ display: 'none' }}
                />

                <input
                  type="text"
                  placeholder="Enter Category"
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  style={styles.input}
                />

                <div style={styles.buttons}>
                  <button onClick={handleSave} style={styles.saveBtn}>Save</button>
                </div>
              </div>
            </div>
          )}



        </div>

        <style>
          {`
    .custom-switch {
      position: relative;
      display: inline-block;
      width: 100px;
      height: 55px;
    }

    .custom-switch input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .custom-slider {
      position: absolute;
      cursor: pointer;
      transition: 0.4s;
      font-weight: bold;
      font-size: 14px;
      color: white;
      text-align: center;
      line-height: 35px;
      width: 100px;
      height: 35px;
    }

    .custom-slider::before {
      content: "";
      position: absolute;
      height: 18px;
      width: 15px;
      left: 5px;
      top: 8px;
      background-color: white;
      transition: 0.4s;
      border-radius: 20px;
    }

    .custom-switch input:checked + .custom-slider::before {
      transform: translateX(60px);
    }
  `}
        </style>


      </div>

      {/* Tab Content */}
      <div>
        {activeTab === "first" && <Grocerymanagement2 />}
        {/* {activeTab === "second" && <Subcategory />} */}
        {activeTab === "third" && <Grocerymenudatas />}
        {/* {activeTab === "fourth" && <Thirdcategaory />} */}
      </div>
    </div>
  );
}

export default GroceryCategories;
